function data() {
  return {
	  express_list:[],
    warehouse_list: [],
    business_type: [],
    country_list: [],
    declare_category: [],
    hk_area: [],
    jiyun_type_list:[],
    oversea_warehouse_enable: ''
  }
}


export default {
  namespaced: true,
  state: data,

  actions: {
    initData({ state }, _data) {
      //   console.log(_data.popup)
      Object.assign(state, _data)
    }
  }
}